module.exports = __webpack_public_path__ + "logo-gda.svg?2e20a623560fb5617c85e7a48ea23284";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-gda.svg
// module id = 186
// module chunks = 0